/* eslint no-unused-vars: 0 */
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';

import * as Actions from '../../../actions/actions';

import WindowEventsHandler from '../../../services/WindowEventsHandler';

/*
- Checks when client presses back button if the form submitted and returns to home page.
 */
export function loadComponent(ComponentWrapped) {
    class LoadingWrapper extends Component {
        constructor() {
            super();
            this.state = { renderComponent: false };
        }

        componentWillMount() {
            this.checkAttributes(this.props);
        }

        componentWillReceiveProps(nextProps) {
            this.checkAttributes(nextProps);
        }

        componentDidMount() {
            WindowEventsHandler.enableUnloadMessage();
        }

        checkAttributes(props) {
            if (!props.loading && !props.submitted) {
                this.setState({ renderComponent: true });
            } else if (!props.loading) {
                browserHistory.push('/');
                this.setState({ renderComponent: false });
            }
        }

        render() {
            return (
                <div>
                    { this.state.renderComponent ? <ComponentWrapped {...this.props} /> : null }
                </div>
            );
        }
    }

    LoadingWrapper.propTypes = {
        loading: React.PropTypes.bool,
        submitted: React.PropTypes.bool,
        started: React.PropTypes.bool,
    };

    function mapStateToProps(state) {
        return {
            loading: state.reducer.get('loading'),
            submitted: state.reducer.get('submitted'),
            started: state.reducer.get('started'),
        };
    }

    return connect(mapStateToProps)(LoadingWrapper);
}



// WEBPACK FOOTER //
// ./src/components/steps/HOC/LoadingWrapper.jsx